const Options = {
  Furnace: 1,
  Producer: 1,
  Lines: {}
}

export default Options



// WEBPACK FOOTER //
// ./src/components/Options.js